import {
  GET_LISTING_DATA_STEP2_START,
  GET_LISTING_DATA_STEP2_SUCCESS,
  GET_LISTING_DATA_STEP2_ERROR
} from '../constants';
import { initialize } from 'redux-form';
import { userListingStepTwo as query } from '../lib/graphql';

export function getListingDataStep2(listId) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: GET_LISTING_DATA_STEP2_START,
    });

    try {
      // Send Request to get listing data
      const { data } = await client.query({
        query,
        variables: { listId: Number(listId), preview: true },
        fetchPolicy: 'network-only',
      });

      if (data?.UserListing) {
        // Reinitialize the form values
        const formValues = {
          ...data.UserListing,
          amenities: (data.UserListing.userAmenities || []).map(item => Number(item.amenitiesId)),
          safetyAmenities: (data.UserListing.userSafetyAmenities || []).map(item =>Number(item.safetyAmenitiesId)),
          spaces: (data.UserListing.userSpaces || []).map(item => (Number(item.spacesId))),
        };
        await dispatch(initialize('ListPlaceStep2', formValues));

        // Dispatch a success action
        dispatch({
          type: GET_LISTING_DATA_STEP2_SUCCESS,
          step2DataIsLoaded: true,
          isExistingList: true,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_LISTING_DATA_STEP2_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }

    return true;
  };
}
